import { Expose } from 'class-transformer'

export class CoverMultiplesForm {
  @Expose()
  coverMultiples: number[]
}
